import React from "react";
import FormWrapper from "../shared/FormWrapper";
import ProgressBar from "../shared/ProgressBar";
import AutoSaveIndicator from "../shared/AutoSaveIndicator";

const helpOptions = [
  { value: "speaking", label: "Speaking / Preaching" },
  { value: "music", label: "Music / Worship Leading" },
  { value: "teaching", label: "Teaching / Training" },
  { value: "youth", label: "Youth Ministry" },
  { value: "children", label: "Children's Ministry" },
  { value: "pastoral", label: "Pastoral Care / Counselling" },
  { value: "admin", label: "Administration" },
  { value: "tech", label: "Tech / AV / Production" },
  { value: "events", label: "Events & Hospitality" },
  { value: "outreach", label: "Outreach & Evangelism" },
  { value: "prayer", label: "Prayer Ministry" },
  { value: "mentoring", label: "Mentoring / Discipleship" },
];

export default function WaysToHelp({
  formData,
  onInputChange,
  onContinue,
  onBack,
  onSaveAndExit,
  saving,
  lastSaved,
}) {
  const selectedWays = formData.waysToHelp || [];

  const toggleOption = (value) => {
    const current = formData.waysToHelp || [];
    if (current.includes(value)) {
      onInputChange(
        "waysToHelp",
        current.filter((v) => v !== value)
      );
    } else {
      onInputChange("waysToHelp", [...current, value]);
    }
  };

  const isSelected = (value) => selectedWays.includes(value);

  return (
    <FormWrapper>
      {/* Back button */}
      <button
        onClick={onBack}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "6px",
          padding: "8px 12px",
          fontSize: "14px",
          fontWeight: "500",
          color: "#737373",
          backgroundColor: "transparent",
          border: "none",
          cursor: "pointer",
          transition: "color 0.2s ease",
          marginBottom: "8px",
        }}
        onMouseEnter={(e) => (e.currentTarget.style.color = "#1a1a1a")}
        onMouseLeave={(e) => (e.currentTarget.style.color = "#737373")}
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <polyline points="15 18 9 12 15 6" />
        </svg>
        Back
      </button>

      {/* Progress Bar */}
      <ProgressBar currentStep={4} totalSteps={5} />

      {/* Icon and Title */}
      <div
        style={{
          textAlign: "center",
          marginBottom: "32px",
          animation: "fadeInUp 0.5s ease",
        }}
      >
        <div
          style={{
            width: "48px",
            height: "48px",
            backgroundColor: "#f0fdf4",
            borderRadius: "12px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 16px",
            border: "1px solid #d1fae5",
          }}
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#10b981"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
          </svg>
        </div>

        <h1
          style={{
            fontSize: "24px",
            fontWeight: "700",
            color: "#1a1a1a",
            marginBottom: "8px",
            letterSpacing: "-0.5px",
          }}
        >
          How would you like to help?
        </h1>
        <p
          style={{
            fontSize: "15px",
            color: "#737373",
            margin: 0,
          }}
        >
          Select all the ways you'd like to serve local churches
        </p>
      </div>

      {/* Checkbox Grid */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(2, 1fr)",
          gap: "10px",
          marginBottom: "24px",
          animation: "fadeInUp 0.5s ease 0.1s both",
        }}
      >
        {helpOptions.map((option) => (
          <button
            key={option.value}
            onClick={() => toggleOption(option.value)}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              padding: "12px",
              fontSize: "13px",
              fontWeight: "500",
              color: isSelected(option.value) ? "#1a1a1a" : "#525252",
              backgroundColor: isSelected(option.value) ? "#f5f5f5" : "#fff",
              border: isSelected(option.value)
                ? "1px solid #1a1a1a"
                : "1px solid #e5e5e5",
              borderRadius: "8px",
              cursor: "pointer",
              transition: "all 0.2s ease",
              textAlign: "left",
            }}
            onMouseEnter={(e) => {
              if (!isSelected(option.value)) {
                e.currentTarget.style.borderColor = "#1a1a1a";
              }
            }}
            onMouseLeave={(e) => {
              if (!isSelected(option.value)) {
                e.currentTarget.style.borderColor = "#e5e5e5";
              }
            }}
          >
            <div
              style={{
                width: "18px",
                height: "18px",
                borderRadius: "4px",
                border: isSelected(option.value)
                  ? "none"
                  : "1.5px solid #d1d5db",
                backgroundColor: isSelected(option.value)
                  ? "#1a1a1a"
                  : "transparent",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              {isSelected(option.value) && (
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#fff"
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              )}
            </div>
            <span style={{ flex: 1, lineHeight: "1.3" }}>{option.label}</span>
          </button>
        ))}
      </div>

      {/* Selection count */}
      {selectedWays.length > 0 && (
        <p
          style={{
            textAlign: "center",
            fontSize: "13px",
            color: "#525252",
            marginBottom: "24px",
            fontWeight: "500",
          }}
        >
          {selectedWays.length} area{selectedWays.length !== 1 ? "s" : ""} selected
        </p>
      )}

      {/* Auto-save indicator */}
      <AutoSaveIndicator saving={saving} lastSaved={lastSaved} />

      {/* Complete Profile Button - dark style matching previous slides */}
      <button
        onClick={onContinue}
        disabled={selectedWays.length === 0}
        style={{
          width: "100%",
          padding: "16px 24px",
          fontSize: "16px",
          fontWeight: "600",
          color: "#fff",
          backgroundColor: selectedWays.length > 0 ? "#1a1a1a" : "#d4d4d4",
          border: "none",
          borderRadius: "8px",
          cursor: selectedWays.length > 0 ? "pointer" : "not-allowed",
          transition: "all 0.2s ease",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "8px",
        }}
        onMouseEnter={(e) => {
          if (selectedWays.length > 0) {
            e.currentTarget.style.backgroundColor = "#333";
            e.currentTarget.style.transform = "translateY(-1px)";
          }
        }}
        onMouseLeave={(e) => {
          if (selectedWays.length > 0) {
            e.currentTarget.style.backgroundColor = "#1a1a1a";
            e.currentTarget.style.transform = "translateY(0)";
          }
        }}
      >
        Complete Profile
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <line x1="5" y1="12" x2="19" y2="12" />
          <polyline points="12 5 19 12 12 19" />
        </svg>
      </button>

      {/* Save & Exit */}
      <button
        onClick={onSaveAndExit}
        style={{
          width: "100%",
          padding: "12px",
          marginTop: "12px",
          fontSize: "14px",
          fontWeight: "500",
          color: "#a3a3a3",
          backgroundColor: "transparent",
          border: "none",
          cursor: "pointer",
          transition: "color 0.2s ease",
        }}
        onMouseEnter={(e) => (e.currentTarget.style.color = "#737373")}
        onMouseLeave={(e) => (e.currentTarget.style.color = "#a3a3a3")}
      >
        Save & finish later
      </button>
    </FormWrapper>
  );
}
